<template>
  <!-- 学校批次 二维码海报弹窗 -->
  <a-modal
    :title="$t('二维码')"
    :visible="qrPosterVisible"
    :confirmLoading="qrPosterLoading"
    :width="420"
    :maskClosable="false"
    @cancel="handleQrPosterClose"
    :footer="null"
  >
    <div class="batch-qr-modal-body">
      <div
        class="batch-qr-poster"
        ref="batchQrPoster"
        :style="{ backgroundImage: `url(${batchQrBg})` }"
      >
        <!-- 顶部欢迎 + 时间区域 -->
        <div class="batch-qr-poster__meta">
          <div class="batch-qr-poster__welcome">
            {{ $t('欢迎使用在线征订系统') }}
          </div>
          <div class="batch-qr-poster__time">
            {{ $t('征订时间') }}：{{ qrPosterInfo.startTime || '-' }}
          </div>
          <div class="batch-qr-poster__time">
            {{ $t('结束时间') }}：{{ qrPosterInfo.endTime || '-' }}
          </div>
        </div>

        <!-- 中间白色卡片 -->
        <div class="batch-qr-poster__card">
          <div class="batch-qr-poster__header">
            <img
              v-if="qrPosterInfo.schoolLogo"
              :src="qrPosterInfo.schoolLogo"
              class="batch-qr-poster__logo"
              alt="logo"
            />
            <div class="batch-qr-poster__school-name">
              {{ qrPosterInfo.schoolName }}
            </div>
          </div>

          <div class="batch-qr-poster__subtitle">
            {{ $t('校服订购工作开始了!请您扫码开始订购。') }}
          </div>

          <div class="batch-qr-poster__qrcode">
            <vue-qr
            v-if="qrPosterMode === 'text' && qrPosterText"
              :text="qrPosterText"
              :size="210"
              :margin="8"
              colorDark="#111"
              colorLight="#FFFFFF"
            />
          <img
            v-if="qrPosterMode === 'image' && qrPosterImage"
            :src="qrPosterImage"
            class="batch-qr-poster__qrcode-image"
            alt="miniapp-qrcode"
          />
          </div>

          <div class="batch-qr-poster__mobile">
            {{ $t('客服电话') }}：{{ qrPosterInfo.mobile || '-' }}
          </div>
          <div class="batch-qr-poster__provider" v-if="qrPosterInfo.providerText">
            {{ qrPosterInfo.providerText }}
          </div>
        </div>
      </div>

      <div class="batch-qr-actions">
        <a-button @click="handleQrPosterClose">{{ $t('取消') }}</a-button>
        <a-button type="primary" :loading="qrPosterExportLoading" @click="handleExportQrPoster">
          {{ $t('下载') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import vueQr from 'vue-qr'
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
import batchQrBg from '@/assets/images/batchQr.jpg'
import { getSchool } from '@/api/school/school'

export default {
  name: 'BatchQrcode',
  components: {
    vueQr
  },
  data () {
    return {
      batchQrBg,
      qrPosterVisible: false,
      qrPosterLoading: false,
      qrPosterExportLoading: false,
      qrPosterMode: 'text',
      qrPosterText: '',
      qrPosterImage: '',
      qrPosterInfo: {
        id: null,
        schoolName: '',
        schoolLogo: '',
        batchName: '',
        startTime: '',
        endTime: '',
        mobile: '',
        providerText: ''
      }
    }
  },
  methods: {
    buildPosterBaseInfo (row) {
      return {
        id: row && row.id ? row.id : null,
        schoolName: row && row.schoolName ? row.schoolName : '',
        schoolLogo: row && row.schoolLogo ? row.schoolLogo : '',
        batchName: row && row.batchName ? row.batchName : '',
        startTime: row && row.startTime ? row.startTime : '',
        endTime: row && row.endTime ? row.endTime : '',
        mobile: row && row.mobile ? row.mobile : '',
        providerText: this.$t('此次征订由青岛威达体育用品有限公司提供')
      }
    },
    // 对外暴露：打开二维码海报
    handleAppQrCode (row) {
      this.qrPosterLoading = true
      this.qrPosterVisible = true
      this.qrPosterMode = 'text'
      this.qrPosterText = ''
      this.qrPosterImage = ''
      this.qrPosterInfo = this.buildPosterBaseInfo(row)

      this.qrPosterText = JSON.stringify({
        batchCode: row.batchCode,
        batchId: row.id,
        schoolId: row.schoolId
      })
    },

    // 对外暴露：打开小程序二维码海报
    openMiniProgram (row, imageUrl) {
      this.qrPosterLoading = true
      this.qrPosterVisible = true
      this.qrPosterMode = 'image'
      this.qrPosterText = ''
      this.qrPosterImage = imageUrl || ''
      this.qrPosterInfo = this.buildPosterBaseInfo(row)
    },
    handleQrPosterClose () {
      this.qrPosterVisible = false
      this.qrPosterLoading = false
      this.qrPosterExportLoading = false
      this.qrPosterMode = 'text'
      this.qrPosterText = ''
      this.qrPosterImage = ''
    },
    async handleExportQrPoster () {
      if (!this.$refs.batchQrPoster) return
      this.qrPosterExportLoading = true
      try {
        const canvas = await html2canvas(this.$refs.batchQrPoster, {
          useCORS: true,
          backgroundColor: null,
          scale: 2
        })

        const fileName = `批次二维码_${this.qrPosterInfo.batchName || this.qrPosterInfo.id || ''}.png`
        if (canvas.toBlob) {
          canvas.toBlob(blob => {
            if (blob) saveAs(blob, fileName)
            this.qrPosterExportLoading = false
          })
        } else {
          const dataUrl = canvas.toDataURL('image/png')
          saveAs(dataUrl, fileName)
          this.qrPosterExportLoading = false
        }
      } catch (e) {
        this.qrPosterExportLoading = false
        this.$message.error(this.$t('导出失败'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.batch-qr-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.batch-qr-poster {
  width: 320px;
  height: 520px;
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.batch-qr-poster__meta {
  position: absolute;
  top: 10px;
  left: 22px;
  right: 22px;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.batch-qr-poster__welcome {
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 10px;
}

.batch-qr-poster__time {
  font-size: 14px;
  text-align: center;
  line-height: 18px;
}

.batch-qr-poster__card {
  position: absolute;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  width: 250px;
  background: #fff;
  border-radius: 10px;
  padding: 16px 14px 14px;
  text-align: center;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.16);
}

.batch-qr-poster__header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.batch-qr-poster__logo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 8px;
}

.batch-qr-poster__school-name {
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.batch-qr-poster__title {
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 20px;
}

.batch-qr-poster__subtitle {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 2px;
  margin-bottom: 10px;
}

.batch-qr-poster__qrcode {
  width: 210px;
  height: 210px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.batch-qr-poster__qrcode-image {
  width: 210px;
  height: 210px;
  object-fit: contain;
}

.batch-qr-poster__hint {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
}

.batch-qr-poster__mobile {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}

.batch-qr-poster__provider {
  margin-top: 10px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}

.batch-qr-actions {
  width: 320px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}
</style>